module.exports = __webpack_public_path__ + "img/scroll-torah.421f880d.svg";